import useStep3 from '../../../application/bloc/useStep3';
import {
  currency,
  currencyKR,
  joinDtDate,
} from '../../../application/helper/filter';

import {
  HeadTitle,
  TextField,
  SelectField,
  Spacer,
  Button,
  MenuBottomsheet,
  TheSearchBottomsheet,
  TheInBizBottomsheet,
  Popup,
} from 'oui';
import { DefaultBox, FloatingBox } from '../../etc/LBox/LBox';
import ScrapNhisFullsheet from '../../component/ScrapNhisFullsheet/ScrapNhisFullsheet';

const Step3 = () => {
  const {
    jobTyp,
    isActive,
    warningJoinDtText,
    inputForms,
    selectSheet,
    onClickOpenSelectSheet,
    navigateNextStep,
    warningSalaryText,
    onChangeCustIncome,
    setCompanyInfo,
    setJoinDt,
    setPersonalInfo,
    joinDtText,
    clearFocus,
    sendBeaconClkBtnInputBiz,
    scrapNhisFullsheet,
    closePopupScrapNhisFullsheet,
    //
    //
    isOpenSearchBottomsheet,
    openSearchBottomsheet,
    closeSearchBottomsheet,
    isOpenInBizBottomsheet,
    openInBizBottomsheet,
    closeSearchAndInBizBottomsheet,
    searchCompany,
    //
    popup,
  } = useStep3();

  const handleClickListItem = (id: string) => {
    if (id.includes('Typ')) {
      onClickOpenSelectSheet(id);
      if (id !== 'jobTyp') {
        clearFocus();
      }
    } else if (id === 'compNm') {
      openSearchBottomsheet();
      clearFocus();
    } else {
      clearFocus();
    }
  };

  const handleClickNextButton = () => {
    setPersonalInfo();
    sendBeaconClkBtnInputBiz('다음');
    navigateNextStep();
  };

  return (
    <>
      {scrapNhisFullsheet && (
        <>
          {/*<div>전자 서명 취소 테스트: {scrapNhisFullsheet.test}</div>*/}
          <ScrapNhisFullsheet
            isOpen={scrapNhisFullsheet.isOpen}
            state={scrapNhisFullsheet.state}
            onClickClose={closePopupScrapNhisFullsheet}
            onClickSubmitReady={scrapNhisFullsheet.load}
            onClickSubmitFail={scrapNhisFullsheet.close}
            onClickCustomInput={scrapNhisFullsheet.close}
          />
        </>
      )}

      <HeadTitle textTitle={'직업과 소득 정보를\n 입력해주세요'} />
      <DefaultBox>
        <SelectField
          inputTitle="직업"
          placeholder={'직업 선택'}
          value={jobTyp?.text ?? ''}
          onClickSelectField={() => handleClickListItem('jobTyp')}
          onChangeSelectField={() => {}}
        />
        {inputForms.hasOwnProperty('employeeTyp') && (
          <>
            <Spacer size={'md'} />
            <SelectField
              inputTitle="고용형태"
              placeholder={'고용형태'}
              value={inputForms?.employeeTyp?.text ?? ''}
              onClickSelectField={() => handleClickListItem('employeeTyp')}
              onChangeSelectField={() => {}}
            />
          </>
        )}
        {inputForms.hasOwnProperty('businessTyp') && (
          <>
            <Spacer size={'md'} />
            <SelectField
              inputTitle="업종"
              placeholder={'업종'}
              value={inputForms?.businessTyp?.text ?? ''}
              onClickSelectField={() => handleClickListItem('businessTyp')}
              onChangeSelectField={() => {}}
            />
          </>
        )}
        {inputForms.hasOwnProperty('compNm') && (
          <>
            <Spacer size={'md'} />
            <SelectField
              inputTitle="회사명"
              placeholder={'회사명'}
              value={inputForms?.compNm ?? ''}
              onClickSelectField={() => handleClickListItem('compNm')}
              onChangeSelectField={() => {}}
            />
          </>
        )}
        {inputForms.hasOwnProperty('joinDt') && (
          <>
            <Spacer size={'md'} />
            <TextField
              inputTitle={
                jobTyp.value === '05'
                  ? '시작년월(예. 202301)'
                  : '입사년월(예. 202301)'
              }
              placeholder="YYYY.MM"
              value={joinDtDate(joinDtText, '.') ?? ''}
              state={joinDtText ? 'focused' : 'enabled'}
              warning={warningJoinDtText}
              inputMode={'numeric'}
              onChangeTextInput={setJoinDt}
              onClickTextField={() => handleClickListItem('joinDt')}
            />
          </>
        )}
        {inputForms.hasOwnProperty('salaryAmt') && (
          <>
            <Spacer size={'md'} />
            <TextField
              inputTitle={'연 소득(세전)'}
              placeholder={'연 소득'}
              value={
                inputForms?.salaryAmt ? currency(inputForms?.salaryAmt) : ''
              }
              state={inputForms?.salaryAmt ? 'focused' : 'enabled'}
              adornment={'만 원'}
              warning={warningSalaryText}
              inputMode={'numeric'}
              helperText={currencyKR(inputForms?.salaryAmt * 10000)}
              onChangeTextInput={onChangeCustIncome}
            />
          </>
        )}
      </DefaultBox>
      <FloatingBox>
        <Button
          configuration={'contained'}
          flexible={true}
          isDisabled={!isActive}
          state={isActive ? 'enabled' : 'disabled'}
          onClick={handleClickNextButton}
          children={'다음'}
        />
      </FloatingBox>
      <MenuBottomsheet
        selectType="confirm"
        isOpenBottomSheet={selectSheet.open}
        title={selectSheet.title}
        onClickCloseMenuBottomsheet={selectSheet.onClose}
        items={selectSheet.items}
        confirmBtnText="다음"
        onConfirm={selectSheet.onChange}
        defaultValue={selectSheet.defaultValue}
        selectTransition={0.5}
      />
      <TheSearchBottomsheet
        isSearchBottomsheetOpen={isOpenSearchBottomsheet}
        onClose={closeSearchBottomsheet}
        onClickRegister={openInBizBottomsheet}
        onRegistCompany={(a, b) => setCompanyInfo(a, b)}
        onSearchCompany={searchCompany}
        hasClearButton
        showIsLoading
      />
      <TheInBizBottomsheet
        isOpenBizBottomsheet={isOpenInBizBottomsheet}
        onClose={closeSearchAndInBizBottomsheet}
        onRegist={(a, b) => setCompanyInfo(a, b)}
      />
      <Popup
        title={popup.message}
        isPopupOpen={popup.open}
        confirmBtn={{ text: popup.confirmText, onClick: popup.onClickConfirm }}
        cancelBtn={{ text: popup.cancelText, onClick: popup.onClickCancel }}
      />
    </>
  );
};

export default Step3;
